import styles from './utils/styles';

const colors = {
  accordion: {
    background: styles.colors.gray[800],
    backgroundHover: styles.colors.gray[600],
    color: styles.colors.white,
  },
  background: styles.colors.gray[900],
  border: styles.colors.gray[600],
  brandPrimary: styles.colors.orange[500],
  brandSecondary: styles.colors.gray[700],
  breadcrumbLinkColor: styles.colors.gray[300],
  carouselBulletHover: styles.colors.orange[500],
  defaultFont: styles.colors.white,
  hamburgerMenuColor: styles.colors.white,
  headerBackground: 'transparent',
  link: styles.colors.orange[500],
  linkHover: styles.colors.orange[600],
  onSaleRed: '#ff2121',
  inputBorder: styles.colors.gray[600],
  inputFontColor: styles.colors.gray[600],
  tagBackground: styles.colors.gray[800],
  tagBackgroundHover: styles.colors.gray[600],
  cardBackground: styles.colors.gray[800],
  cardBackgroundHover: styles.colors.gray[700],
  cardText: styles.colors.white,
  searchBorder: styles.colors.gray[200],
  searchInput: styles.colors.gray[500],
  navSearchAllResultsColor: styles.colors.gray[500],
  navSearchHitsContainerText: styles.colors.gray[800],
  searchFormHitBorderColor: styles.colors.gray[200],
  hero: {
    mobileHeadlineColor: 'white',
  },
};

export default colors;
